import Vue from 'vue'


const SHIPPING_WEIGHT_THRESHOLD = 500

const state = {
    cartItems: []
}

const getters = {
    getCartItems: state => state.cartItems,

    getTotalPrice: state => {
        let totalPrice = 0
        for (const item of state.cartItems)
            totalPrice += (item.price - (item.price * item.discount / 100)) * item.amountOrdered
        return totalPrice
    },

    getTotalPriceWithShipping: (state, getters) => {
        return getters.getTotalPrice + getters.getShippingCost
    },

    getShippingCost: state => {
        let totalWeight = 0
        for (const item of state.cartItems)
            totalWeight += item.weight * item.amountOrdered
        return totalWeight > SHIPPING_WEIGHT_THRESHOLD ? 500 : 450
    }
}

const actions = {
    addCartItem: ({commit, state}, item) => {
        if (item.amountOrdered > item.amountInStock)
            throw new Error(`Amount ordered can't be larger than amount in stock. Request obj: ${item}`)

        const existingItem = findFirstCartItemById(state, item.id)
        const isInvalidAmount = existingItem && (existingItem.amountOrdered + item.amountOrdered > existingItem.amountInStock)
        if (isInvalidAmount) {
            Vue.notify({
                group: 'errors',
                title: 'Greška!',
                text: 'Nema dovoljno proizvoda na stanju'
            })
            return
        }
        commit('addCartItem', item)
        Vue.notify({
            group: 'success',
            text: 'Proizvod uspesno dodat u korpu'
        })
    },

    incrementAmountOrdered: ({commit, state}, id) => {
        const existingItem = findFirstCartItemByIdOrThrow(state, id)
        const invalidAmount = existingItem.amountOrdered + 1 > existingItem.amountInStock
        if (invalidAmount)
            throw new Error(`Amount ordered can't be larger than amount in stock. Request obj: ${existingItem}`)
        commit('incrementAmountOrdered', id)
    },

    decrementAmountOrdered: ({commit, state}, id) => {
        const existingItem = findFirstCartItemByIdOrThrow(state, id)
        const invalidAmount = existingItem && (existingItem.amountOrdered - 1 < 0)
        if (invalidAmount)
            throw new Error(`Amount ordered can't be less than 0. Request obj: ${existingItem}`)

        if (existingItem.amountOrdered - 1 === 0)
            commit('removeCartItem', id)
        else
            commit('decrementAmountOrdered', id)
    },

    removeCartItem: ({commit}, id) => {
        commit('removeCartItem', id)
    }
}

const mutations = {
    addCartItem: (state, item) => {
        // For items with smells, we need to treat them as separate cart items
        // Find existing item by both ID and smell ID
        let existingItem = null
        
        if (item.selectedSmell) {
            // Look for existing item with same ID and smell ID
            existingItem = state.cartItems.find(cartItem => 
                cartItem.id === item.id && 
                cartItem.selectedSmell && 
                cartItem.selectedSmell.id === item.selectedSmell.id
            )
        } else {
            // Look for existing item with same ID and no smell
            existingItem = state.cartItems.find(cartItem => 
                cartItem.id === item.id && 
                !cartItem.selectedSmell
            )
        }
        
        if (existingItem) {
            const index = state.cartItems.indexOf(existingItem)
            existingItem.amountOrdered += item.amountOrdered
            state.cartItems.splice(index, 1, existingItem)
        } else {
            state.cartItems.push(item)
        }
    },

    incrementAmountOrdered: (state, id) => {
        const existingItem = findFirstCartItemByIdOrThrow(state, id)
        const index = state.cartItems.indexOf(existingItem)
        existingItem.amountOrdered += 1
        state.cartItems.splice(index, 1, existingItem)
    },

    decrementAmountOrdered: (state, id) => {
        const existingItem = findFirstCartItemByIdOrThrow(state, id)
        const index = state.cartItems.indexOf(existingItem)
        existingItem.amountOrdered -= 1
        state.cartItems.splice(index, 1, existingItem)
    },

    removeCartItem: (state, id) => {
        const existingItem = findFirstCartItemByIdOrThrow(state, id)
        const index = state.cartItems.indexOf(existingItem)
        state.cartItems.splice(index, 1)
    },

    clearCart: state => state.cartItems = []
}


const findFirstCartItemById = (state, id) => state.cartItems.filter(item => item.id === id)[0]

const findFirstCartItemByIdOrThrow = (state, id) => {
    const item = findFirstCartItemById(state, id)
    if (!item)
        throw new Error(`Cart item with id ${id} wasn't found!`)
    return item
}

export default {
    state,
    getters,
    actions,
    mutations
}
